export function createJsonTransformOptions(metrics, filterColor, allMetrics) {
  const metricsData = {
    titles: [],
    shortMetrics: [],
    subscripts: [],
    units: [],
  };

  metrics.forEach((metric) => {
    const m = allMetrics[metric];
    if (m) {
      metricsData.titles.push(m.displayName);
      metricsData.shortMetrics.push(m.short);
      metricsData.subscripts.push(m.subscript);
      metricsData.units.push(m.unit);
    }
  });

  return {
    filterColor: [filterColor],
    'totals.stdDeviation': [0],
    'metric.name': metrics,
    'metric.short': metricsData.shortMetrics,
    'metric.subscript': metricsData.subscripts,
    'metric.displayName': metricsData.titles,
    'metric.unit': metricsData.units,
  };
}

export default createJsonTransformOptions;
